mutation ComputeDeliverablePreview(
    $campaignId: ID!
    $computedDeliverableIdentifiers: [InputComputedDeliverableIdentifier]!
    $emailAddresses: [String]
    $reportingLabels: SCALAR_MIXED
) {
    computeDeliverablePreview(
        campaignId: $campaignId
        computedDeliverableIdentifiers: $computedDeliverableIdentifiers
        emailAddresses: $emailAddresses
        reportingLabels: $reportingLabels
    ) {
        idHash
        url
    }
}
